import React from 'react';
import { ComponentProps } from './types';

import './NewsletterError.scss';

const NewsletterError = ({message}: ComponentProps) => <div className="audit-email-popup-error-message">
	{message}
</div>;

export default NewsletterError;